import {
  callsWorkingMetricDef,
  phonesCustomizedMetricDef,
  phonesRegisteredMetricDef,
} from './metrics/phones';
import {
  autoMessagingOnMetricDef,
  manualMessagingMetricDef,
  newUsersAddedMetricDef,
} from './metrics/software';
import {
  dataSyncInstalledMetricDef,
  statusMappingSetMetricDef,
  writebacksMetricDef,
} from './metrics/data-sync';
import { tenDlcMetricDef } from './metrics/ten-dlc';
import {
  paymentsWithTerminalMetricDef,
  stripeAccountMetricDef,
} from './metrics/payments';
import {
  digitalFormsSubmittedMetricDef,
  formCreatedMetricDef,
} from './metrics/digital-forms';
import { onlineScheduleHealthMetricDef } from './metrics/online-schedule';
import { csvUploadedMetricDef } from './metrics/csv-upload';
import {
  connectPayersMetricDef,
  faxMetricDef,
  missedCallSmsMetricDef,
  reviewsEnabledMetricDef,
} from './metrics/additional-features';
import { UnifyMetricDefinition } from './unify-metrics.types';

export const UNIFY_METRIC_DEFINITIONS: UnifyMetricDefinition[] = [
  // Phones
  callsWorkingMetricDef,
  phonesCustomizedMetricDef,
  phonesRegisteredMetricDef,

  // Software
  manualMessagingMetricDef,
  newUsersAddedMetricDef,
  autoMessagingOnMetricDef,

  // Data Sync
  dataSyncInstalledMetricDef,
  writebacksMetricDef,
  statusMappingSetMetricDef,

  // 10 DLC
  tenDlcMetricDef,

  // Payments
  stripeAccountMetricDef,
  paymentsWithTerminalMetricDef,

  // Digital Forms
  digitalFormsSubmittedMetricDef,
  formCreatedMetricDef,

  // Online Schedule
  onlineScheduleHealthMetricDef,

  // CSV Upload
  csvUploadedMetricDef,

  // Additional Features
  reviewsEnabledMetricDef,
  missedCallSmsMetricDef,
  faxMetricDef,
  connectPayersMetricDef,
];

export const UNIFY_METRIC_DEFINITIONS_MAP: Record<string, UnifyMetricDefinition> =
  UNIFY_METRIC_DEFINITIONS.reduce((acc, def) => {
    acc[def.id] = def;
    return acc;
  }, {} as Record<string, UnifyMetricDefinition>);

export const UNIFY_SECTION_NAMES: string[] = Array.from(
  new Set(UNIFY_METRIC_DEFINITIONS.map((def) => def.sectionName))
);
